// extracted by mini-css-extract-plugin
module.exports = {"text":"styles-module__text___1-SQS","showMoreButton":"styles-module__showMoreButton___3NAZN"};